/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import TradeWidget from "./components/TradeWidget";
import { Skeleton, Stack, Typography, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import classNames from "classnames";
import styles from "./sass/assets.module.scss";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Assets from "./components/Assets";
import Chart from "./components/Chart";
import ReactMarkdown from 'react-markdown'
import { ChevronDown } from "mdi-material-ui";
import { getMeta } from "./helpers/meta";


const Asset = (props) => {

  // state
  const [asset, setAsset] = useState(null);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState("panel0");
  const [meta, setMeta] = useState([]);

  // redux
  const assets = useSelector((state) => state.assets);

  // hooks
  const params = useParams();

  // lifecycles
  useEffect(() => {
    if (!assets.loading) {
      const findAsset = assets.list.find((asset) => {
        return asset.id === params.asset_id;
      });
      if(findAsset) {
        setAsset(findAsset);
        setLoading(false);
        handleGetMeta();
      }
    }
  }, [assets, assets.list]);

  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  const handleGetMeta = async () => {
    const [err, response] = await getMeta();
    if (!err) {
      setMeta(response.data);
    }
  }

  // methods
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className={classNames(styles["asset"], "container mt-3")}>
      <div className="row">
        <div className="col-md-8 col-12">
          <Assets id={params.asset_id} {...props} />
          {loading ? (
            <>
              <Stack spacing={1} className="my-3">
                <Skeleton variant="rectangular" height={150} />
                <Skeleton variant="rectangular" height={150} />
              </Stack>
            </>
          ) : (
            <>
              <div className="mt-3">
                <Chart id={params.asset_id} />
              </div>
              <div className={classNames(styles["description"], "row mt-5")}>
                <div className="col-12">
                  <Accordion expanded={expanded === 'panel0'} onChange={handleChange('panel0')} className="mb-0">
                    <AccordionSummary
                      expandIcon={<ChevronDown />}
                      className="my-0"
                    >
                      <Typography variant="h6" className="mb-0">
                        About {asset.name}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <ReactMarkdown children={asset.description}/>
                    </AccordionDetails>
                  </Accordion>
                  {
                    meta.map((item,i) => {
                      let panelId = `panel${i+1}`;
                      return (
                        <Accordion key={i} expanded={expanded === panelId} onChange={handleChange(panelId)} className="mb-0">
                           <AccordionSummary
                              expandIcon={<ChevronDown />}
                            >
                            <Typography variant="h6">
                              { item.description.header }
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            {
                              item.description?.image && item.description?.image?.formats["small"] && <img src={item.description.image.formats["small"]?.url} alt="logo" className="img-fluid"/>
                            }
                            <ReactMarkdown children={item.description.body}/> 
                          </AccordionDetails>
                        </Accordion>
                      )
                    })
                  }
                </div>
              </div>
            </>
          )}
        </div>
        <div className="col-md-4 col-12 mt-3 mt-md-0 mb-3">
          <TradeWidget {...props}/>
        </div>
      </div>
    </div>
  );
};

export default Asset;
